module.exports = window["jQuery"];